exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.itemListing {\n  background: #eee;\n  padding: 5px;\n}\n", ""]);

// exports
